<template>
	<section class="sub_container">
    <div class="search_form">
      <h2>상품조회</h2>
			<div class="contents">
				<div class="row">
          <div class="cell w100-p">
            <label for="">상품 번호</label>
            <div class="form-group mt10">
							<input type="text" class="input-text w100-p" placeholder="상품 번호"
									v-model="brandProductId"
									@keyup.enter="searchBtn">
						</div>
						<div class="sub_sh_btn_wrap">
							<button class="sh_btn" @click="searchBtn">조회</button>
						</div>
          </div>
				</div>
			</div>
    </div>
    <div class="sub_contents">
      <div class="sub_contents_wrap">
        <div class="board_list type03 tbl_box">
					<table class="board_table" style="table-layout:fixed; width:480px;">
						<!-- 지정(상품코드, 상품명, 안성물류, 서울물류, 시중가, 도매가, 보험단가) 항목만 -->
						<caption class="hide">상품주문 조회 테이블</caption>
						<colgroup>
							<col style="width:40px;">
							<col style="width:100px;">
							<col style="width:150px;">
							<col style="width:60px;">
							<col style="width:60px;">
							<col style="width:70px;">
						</colgroup>
						<thead>
							<tr>
								<th scope="col"> No </th>
								<th scope="col"> 상품코드 </th>
								<th scope="col"> 상품명 </th>
								<th scope="col"> 안성물류 </th>
								<th scope="col"> 서울물류 </th>
								<th scope="col"> 단가 </th>
							</tr>
						</thead>
						<tbody>
              <tr v-for="(data, index) in dataList" v-bind:key="index">
								<td>{{index + 1}}</td>
								<td>{{data.brandProductId}}</td>
								<td class="tal">{{data.productName}}</td>
								<td class="tar">{{Utils.numberComma(data.anseongAmount)}}</td>
								<td class="tar">{{Utils.numberComma(data.seoulAmount)}}</td>
								<td class="tar">{{Utils.numberComma(data.priceValue)}}</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="board_list_bottom mt10">
					<div class="sub_center_wrap">
						<div class="btn_area pt0">
							<!-- <a class="button white"><span>초기화</span></a>
							<a class="button dark"><span>주문항목 담기</span></a> -->
						</div>
					</div>
				</div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import Utils from '@/modules/utils'
import SelectCodeList from '@/components/SelectCodeList'

export default {
  name: 'productInquiry',
	components: { SelectCodeList },
	data() {
		return {
      AppConfig,
      Utils,
			brandProductId: '',
			dataList: []
		}
	},
	methods: {
		searchBtn() {
			const searchUrl = '/local/estimate/brand/product';
			const params = {
				brandNo: 0,
				brandProductId: this.brandProductId,
				brandProductName: ''
			}

			this.dataList = [];

			Utils.showLoading('loading_grid_productList');

			Vue.httpClient
				.get(searchUrl, {params})
				.then(response => {
          if (response.data.result) {
						this.dataList = response.data.result;
					}
				})
				.finally(_ => {
					Utils.hideLoading('loading_grid_productList');
				})
		}
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/product/ProductInquiry.vue